import {
  AssignmentApi,
  Configuration,
  DevicesApi,
  ParticipantsApi,
  IamApi,
} from '@/generated/api/study';
import { defineStore } from 'pinia';
import { Dictionary } from '@/util/interfaces';

export interface StudyApiState {
  basePath: string;
  baseOptions: {
    headers: Dictionary<string>;
  };
  accessToken: string;
}

export const useStudyApi = defineStore({
  id: 'studyApi',
  state: (): StudyApiState => ({
    // will be set to "devicehub_study_app_base_path" from DMS client app setting "config"
    basePath: '',
    baseOptions: {
      headers: {},
    },
    accessToken: '',
  }),

  getters: {
    deviceApi(): DevicesApi {
      return new DevicesApi(
        new Configuration({
          basePath: this.basePath,
          baseOptions: this.baseOptions,
          accessToken: this.accessToken,
        }),
      );
    },
    assignmentApi(): AssignmentApi {
      return new AssignmentApi(
        new Configuration({
          basePath: this.basePath,
          baseOptions: this.baseOptions,
          accessToken: this.accessToken,
        }),
      );
    },
    participantApi(): ParticipantsApi {
      return new ParticipantsApi(
        new Configuration({
          basePath: this.basePath,
          baseOptions: this.baseOptions,
          accessToken: this.accessToken,
        }),
      );
    },
    iamApi(): IamApi {
      return new IamApi(
        new Configuration({
          basePath: this.basePath,
          baseOptions: this.baseOptions,
          accessToken: this.accessToken,
        }),
      );
    },
  },

  actions: {
    setBasePath(basePath: string) {
      this.basePath = basePath;
    },

    setHeaders(headers: Dictionary<string>) {
      this.baseOptions.headers = headers;
    },

    setAccessToken(accessToken: string) {
      this.accessToken = accessToken;
    },
  },
});
